var bankcd = "";
var cardno = "";
var custna = "";
var idtfno = "";
var banknm = "";
var phone = "";
var idtftp="";
var isCooldown = false;
var codeToken = "";
var returnType = 0;
$(function() {
    $("#phone").val(localStorage.g_mobile);
    returnType = getParamsByName("returnType");
})

function next1() {

    cardno = getValue('cardno'); //绑定卡号
    custna = getValue('custna'); //卡开户名称
    idtfno = getValue('idtfno'); //证件号码

    $("#idtfno").val(idtfno.toUpperCase());

    idtftp= getValue('numberTyp');
    if (checkRequired2('cardno', '银行卡号不能为空') && checkRequired2('custna', '真实姓名不能为空') && checkRequired2('idtfno', '身份证号码不能为空')) {

    } else {
        return;
    }


    toApi('getBankInfoByCard.tml?cardno=' + cardno, function(data) {
        banknm = data.banknm;
        bankcd = data.bankcd; // 行号
        if (data.cardtp == 0 || data.cardtp == "0") {
            $('#cardTypeMsg').html(banknm + " 贷记卡");
        } else if (data.cardtp == 1 || data.cardtp == "1") {
            $('#cardTypeMsg').html(banknm + " 借记卡");
        } else if (data.cardtp == 2 || data.cardtp == "2") {
            $('#cardTypeMsg').html(banknm + " 准贷记卡");
        } else if (data.cardtp == 3 || data.cardtp == "3") {
            $('#cardTypeMsg').html(banknm + " 预付费卡");
        }

        // toApi('resetTransPwdChk.tml?cardno=' + cardno + '&idtfno=' + idtfno + '&custna=' + custna + '&idtftp=0&brchno=' + bankcd, function (data) {
        //     if(data.respCode=="000000"){
        //         $('#step1').addClass('none');
        //         $('#step2').removeClass('none');
        //     }
        // });
        toApi({
            url: 'resetTransPwdChk.tml',
            cardno: cardno,
            idtfno: $("#idtfno").val().toUpperCase(),
            custna: custna,
            certType: idtftp,
            brchno: bankcd
        }, function(data) {
            if (data.respCode == "000000") {

                $('#step1').addClass('none');
                $('#step2').removeClass('none');
                $('#firstAnchor').removeClass('none');
            }
        }, "find-transpwd", "");

    }, "find-transpwd", "");


    log('getBankInfoByCard.tml?cardno=' + cardno);
}

function getVcode() {

    phone = getValue('phone');
    if (checkRequired2("phone", '手机号不能为空') && checkMoblie2('phone', '请输入正确的手机号')) {
        if (!isCooldown) {
            
            
            toApi('getvcodepcin.tml?phone=' + phone + '&vcodeType=3', function(data) {
                alertMsg("短信验证码发送成功");
                $('#e_vcode').addClass('none');
                $('#msgBtn').css('color', '#999999');
                isCooldown = true;
                $('#msgBtn').removeClass("mouse");
                isChooseBtn = true; //已获取验证码
                $("#msgBtn").html('120秒后重发');
                var k = 119;
                timerid = window.setInterval(function() {
                    if (k > 0) {
                        $("#msgBtn").html(k + "秒后重发");
                    } else {
                        timerid = window.clearInterval(timerid);
                        isCooldown = false;
                        $("#msgBtn").html("重新获取");
                        $('#msgBtn').css('color', '#58a3ff');
                        $('#msgBtn').addClass("mouse");
                    }
                    k--;
                }, 1000);
            });
        }
    }
}

function checkVcode() {
    var vcode = getValue('vcode');

    if (checkRequired2('phone', '手机号不能为空') && checkRequired2('vcode', '验证码不能为空')) {

    } else {
        return;
    }
	if ($('#agree').prop('checked')) {
		// do something
	} else {
		$('#e_agree').removeClass('none');
	    return;
	}
      
	if(isCooldown){
	    toApi('checkVcode.tml?vcodeType=3&phone=' + phone + '&vcode=' + vcode, function(data) {
	        $('#step2').addClass('none');
	        $('#step3').removeClass('none');
	    });
    }else{
    	errShow('vcode', '请点击获取验证码');
        return;
    
    }
}

function resetTransPwd() {
    closeKeypad();
    closeKeypad2();
    if (checkRequired2('newTransPwd', '密码不能为空') && checkRequired2('renewTransPwd', '重复密码不能为空')) {

    } else {
        return;
    }
    var newTransPwd = $('#newTransPwd').val();
    var renewTransPwd = $('#renewTransPwd').val();


    if (newTransPwd.length < 6) {
        errShow('newTransPwd', '交易密码由6位数字组成!');
        return;
    }


    if (newTransPwd != renewTransPwd) {
        errShow('renewTransPwd', '两次交易密码输入不一致!');
        return;
    }

    if (!checkSetTransPwd("newTransPwd", idtfno, phone, $("#newTransPwd").val())) {
        errShow('newTransPwd', '交易密码过于简单!');
        return;
    }
    $('#newTransPwd').val('');
    $('#renewTransPwd').val('');

    //通过[密钥下发]接口获取密码RSA秘钥
    toApi('getPubKey.tml?type=' + 2, function(data) {

        var publicKey = data.key;
        var r_newTransPwd = RSAUtil_transPwd(newTransPwd, publicKey);
        var r_renewTransPwd = RSAUtil_transPwd(renewTransPwd, publicKey);

        //通过[验证交易密码]接口验证用户输入的交易密码147258
        toApi('resetTransPwd.tml?custna=' + encodeURI(custna) + '&idtfno=' + idtfno.toUpperCase() + '&brchno=' + bankcd + '&cardno=' + cardno + '&custac=&phone=' + phone + '&newtpw=' + r_newTransPwd + '&newtpwchk=' + r_renewTransPwd+'&idtftp='+idtftp , function(data) {

            $('#step3').addClass('none');
            $('#step4').removeClass('none');
        });

    });


}

function goback_step1() {
    $('#step2').addClass('none');
    $('#step1').removeClass('none');
}

function goback_step2() {
    closeKeypad();
    closeKeypad2();
    $('#newTransPwd').val('');
    $('#renewTransPwd').val('');
    $('#step3').addClass('none');
    $('#step2').removeClass('none');
}

function returnBack() {
    if (returnType == 0)
        location = phURL + "personal/personal.html";
    else if (returnType == 1)
        gotoAddmybindbankcard();
    else if (returnType == 2)
        location = phURL + "personal/removemybindbankcard.html";
    else {
        history.back(-1);
    }
}